// extracted by mini-css-extract-plugin
export var navbarSubLink = "X_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "X_yh d_f0 d_dB";
export var subPageLink = "X_gf d_gf";
export var burger = "X_yl";
export var sublinkSize = "X_ym";
export var linkSize = "X_yn";
export var Link = "X_tx y_tx y_sP y_s7";